import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { BASEURL } from "../Config";
import swal from 'sweetalert';
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import TrackingSalesManager from './TrackingSalesManager';
import SalesManagerCard from './SalesManagerCard';
import { useLocation } from 'react-router-dom';
import '../assets/enhanced-tracking.css';

const ViewSalesManager = (props) => {
    const uuid = props.match.params.uuid;
    const location = useLocation();

    const initialTrackingState = useMemo(() => {
        const params = new URLSearchParams(location.search);
        return {
            overviewMonth: params.get('overviewMonth') ? parseInt(params.get('overviewMonth')) : null,
            overviewYear: params.get('overviewYear') ? parseInt(params.get('overviewYear')) : null,
            selectedDate: params.get('selectedDate') || null
        };
    }, []);
    const [salesManager, setSalesManager] = useState(null);
    const [stats, setStats] = useState({
        eventsCount: 0,
        schoolsCount: 0,
        distributorsCount: 0
    });

    useEffect(() => {
        fetchSalesManager();
        fetchStats();
    }, []);

    const fetchSalesManager = async () => {
        await axios.get(`${BASEURL}/api/v1/salesManager/${uuid}`)
            .then(res => {
                setSalesManager(res.data);
            })
            .catch(err => {
                console.log("Fetch salesManager error", err);
                swal('Error', 'Failed to fetch Sales Manager details', 'error');
            });
    };

    const fetchStats = async () => {
        try {
            const response = await axios.get(`${BASEURL}/api/v1/salesManager/${uuid}/stats`);
            if (response.data) {
                setStats({
                    eventsCount: response.data.eventsCount || 0,
                    schoolsCount: response.data.schoolsCount || 0,
                    distributorsCount: response.data.distributorsCount || 0
                });
            }
        } catch (err) {
            console.log("Fetch stats error", err);
        }
    };

    return (
        <div id="wrapper">
            <Sidebar act="salesManagers" />
            <div className="content-page">
                <div className="content">
                    <Topbar act="View Sales Manager" breadcrumbItems={['Sales App', { label: 'Sales Managers', path: '/salesManagers' }, 'View Sales Manager']} />
                    <div className="container-fluid">
                        {/* Enhanced Profile Card with Stats */}
                        <SalesManagerCard salesManager={salesManager} stats={stats} />

                        {/* Enhanced Tracking Section with Calendar and Events */}
                        {salesManager && (
                            <TrackingSalesManager
                                salesManagerUUID={uuid}
                                salesManager={salesManager}
                                onStatsUpdate={setStats}
                                initialTrackingState={initialTrackingState}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewSalesManager;
